<refx-basic-layout>
  <div messagePanel class="message">
    <ng-container *ngIf="!rebookingInProgress">
      <ng-container *ngIf="!(deeplinkConfigError || deeplinkDapiForbiddenError)">
        <ng-container *ngIf="!(noItineraryExistInOrder$ | async)">
          <refx-messages-panel-pres *ngIf="uiMessageService.uiErrors$ | async as errors"
            class="error-message-panel"
            [panelType]="'information'"
            [translations]="{title: errors.length > 0 ? errors[0].titleKey.key : translations.defaultError }"
            [messages]="[{type: 'error', titleKey: { key: translations.contactSupport }}]">
          </refx-messages-panel-pres>
        </ng-container>
        <refx-messages-panel-pres *ngIf="(noItineraryExistInOrder$ | async)"
          class="information-message-panel no-itinerary-info-panel"
          [panelType]="'information'"
          [translations]="{title: translations.pnrAlreadyCancelledInfoTitle }"
          [messages]="[{type: 'error', titleKey: { key: translations.pnrAlreadyCancelledInfoMessage }}]">
        </refx-messages-panel-pres>
      </ng-container>
      <refx-generic-error-panel-cont *ngIf="deeplinkConfigError || deeplinkDapiForbiddenError"
        [deeplinkConfigError]="deeplinkConfigError"
        [deeplinkDapiForbiddenError]="deeplinkDapiForbiddenError">
      </refx-generic-error-panel-cont>
    </ng-container>
    <ng-container *ngIf="rebookingInProgress">
      <refx-messages-panel-pres
          class="information-message-panel rebooking-info-panel"
          [panelType]="'information'"
          [translations]="{title: translations.rebookingInProgressTitle }"
          [messages]="[{type: 'error', titleKey: { key: translations.rebookingInProgressMessage }}]">
        </refx-messages-panel-pres>
    </ng-container>
  </div>
  <div mainContent class="recovery-refund-container" *ngIf="(config$ | async)?.showRefundTeaser && (checkOrderEligibilityForRefundTeaser$ | async)">
    <o3r-placeholder id="ph-refx-refund-teaser-cont-top"></o3r-placeholder>
    <refx-refund-teaser-cont
      [customRefundTeaserTitle]="translations.customRefundTeaserTitle | o3rTranslate"
      [customRefundTeaserBody]="translations.customRefundTeaserBody | o3rTranslate"
      [customRefundTeaserButtonLabel]="translations.customRefundTeaserButtonLabel | o3rTranslate"
      (refund)="goToRefund()"
    >
    </refx-refund-teaser-cont>
    <o3r-placeholder id="ph-refx-servicing-recovery-bottom"></o3r-placeholder>
  </div>
  <div footer>
    <div class="button-panel" *ngIf="!(noItineraryExistInOrder$ | async); else nextFlightButton">
      <ng-container *ngIf="(recLoc$ | async) as recLoc">
        <ng-container *ngIf="(lastName$ | async) as lastName">
          <ng-container *ngIf="(translations.retrieveBookingButtonUrl | o3rTranslate : {recLoc, lastName}) || '_blank' as linkUrl">
            <a mat-stroked-button
              class="button retrieve-booking"
              *ngIf="(config$ | async)?.showRetrieveBookingButton"
              (click)="navigate(linkUrl)"
              (keydown.enter)="navigate(linkUrl)"
              [innerHTML]="translations.retrieveBookingButtonLabel | o3rTranslate">
            </a>
          </ng-container>
        </ng-container>
      </ng-container>
      <span class="button back-to-mmb-button">
        <ng-template
          *ngIf="(config$ | async)?.showBackToMmbButton"
          c11n
          [component]="backToMmbComponent$ | async">
        </ng-template>
      </span>
      <a
        mat-flat-button
        class="button contact-support"
        *ngIf="(translations.contactSupportUrl | o3rTranslate) as contactSupportUrl"
        [attr.href]="contactSupportUrl"
        target="_blank"
        trackClick
        [trackEventContextConstructor]="analyticsEvents.clickOnCallCenterNumber"
      >
        <span [innerHTML]="translations.contactSupportButton | o3rTranslate"></span>
      </a>
    </div>
    <ng-template #nextFlightButton>
      <refx-message-display-pres
        class="search-next-flight-container"
        [titleContent]="translations.nextTravel | o3rTranslate"
        [messageContent]="translations.nextFlight | o3rTranslate"
        [buttonContent]="translations.searchNextFlight | o3rTranslate"
        [urlTargeted]="translations.nextFlightUrl | o3rTranslate"
        [displayButton]="true"
        [useMatStrokedButton]="false">
      </refx-message-display-pres>
    </ng-template>
  </div>
</refx-basic-layout>
